
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {tap, map} from 'rxjs/operators';
import { Injectable, Inject, forwardRef } from '@angular/core';
import { Http, Response, Headers  } from '@angular/http';

import { LoginModel } from './models/login-model';
import {environment} from '../../environments/environment'
import { UserProfileService } from './user-profile.service';

@Injectable()
export  class LoginService  {
private domainStr: string;
  public constructor(private http: Http, private userProfileService:UserProfileService) {
    this.domainStr = environment.baseWebApiUrl;
    userProfileService.loginService = this;

  }
  private RIABASE_URL: string = "api/RIA/";

  public login(user: LoginModel):Observable<string> {

    return this.http
      .post(this.domainStr + "api/RateAuditAccount/Login", {userName: user.username, password: user.password}).pipe(
      map((response: Response) => {
        //console.log(JSON.stringify(response));
        let str = response.text();
        if (str) {
          return str;
        }
        return "good"}));
  }

  public logout() {
      return this.http
      .post(this.domainStr + "api/RateAuditAccount/Logout", {}).pipe(
      
      tap( response => {
        var data = response.json();
        if(data.isSSOLogout){
        window.location.href= data.PortalURL;
      }
      //  window.location.href= response;
        console.log(JSON.stringify(response)),console.log("logged out")
      }));
  }

  public userInfo() {
    return this.http
    .get(this.domainStr + "api/RateAuditAccount/UserInfo").pipe(
    map((response: Response) => {
      return response.json()}),
      map(data => {
        if (data.ProductAccess==null) {
          data.ProductAccess=[];
        }
        return data;
      }),);
  }

  public SecurityGetUser()
  {
         return this.http
           .post(this.domainStr + this.RIABASE_URL + 'SecurityGetUser', {PortalSSO:''}).pipe(
          map((response: Response) => {return response.json();}))
          //.do(d => console.log('SecurityGetUser ' + JSON.stringify(d)))
          ;
  }
  public updateSessionSetCustomer( c:number)
  {
    let customerID = c.toString();
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

         return this.http
          .post(this.domainStr + 'api/UserSession/SetCustomer', c, {headers:headers} ).pipe(
          map((response: Response) => {return response.json();}),
          tap(d => d,
            e => this.handleError(e)
          ),);

  }
  private handleError(error: Response) {
    console.error(error);
    let msg = `Error status code ${error.status} at ${error.url}`;
    return observableThrowError(msg);
  }

}
